import { atom } from "jotai";

// ATOMS - Primitive, ReadOnly, WriteOnly, ReadWrite
// Primitive - Just pass them an initial value, and update anywhere (update with useAtom or in derived atoms)
// ReadOnly - Pass them a single arrow function that captures get, and you can react to another atom's updates.
// WriteOnly - Pass null as first function, then the 2nd arrow function is used to write the atoms value. You can capture get and set in the arrow function.
// ReadWrite - Combination of ReadOnly/WriteOnly, pass arrow function for initializing/reactive updates / pass another for updating the atoms value.

// ReadOnly Atom storing the current workspace
export const workspaceIdAtom = atom<string | null>(null);
